import { AsyncPipe, NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
    signal,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StorageTemporaryLinkPipe } from '@interacta-shared/data-access-storage-temporary-link';
import {
    CheckboxComponent,
    IconButtonComponent,
    ImageComponent,
    InputTextComponent,
    ProgressLoaderComponent,
} from '@interacta-shared/ui';
import { CreationDateComponent } from '@interacta-shared/ui-common';
import { FormatBytesPipe } from '@interacta-shared/util-common';
import { getAttachmentsMimetype, IAttachment } from '@interacta/util-post';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-attachment-version',
    templateUrl: './attachment-version.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        AsyncPipe,
        MatTooltipModule,
        TranslatePipe,
        CheckboxComponent,
        CreationDateComponent,
        IconButtonComponent,
        ImageComponent,
        InputTextComponent,
        ProgressLoaderComponent,
        StorageTemporaryLinkPipe,
        FormatBytesPipe,
    ],
})
export class AttachmentVersionComponent {
    readonly version = input.required<Partial<IAttachment>>();
    readonly control = input.required<FormControl<string | null>>();
    readonly useVersionNameForAttachment = input(false);

    readonly removeVersion = output<void>();
    readonly cancelUpload = output<void>();
    readonly changeCheck = output<boolean>();

    readonly mimeType = computed(() =>
        getAttachmentsMimetype(this.version().contentMimeType),
    );

    readonly now = new Date();
    readonly hoverRow = signal(false);
}
